//import { SystemSecurityUpdateWarning } from "@mui/icons-material";
import { SxProps, Theme } from "@mui/material";
import MuiAutocomplete from "@mui/material/Autocomplete";
import MuiTextField from "@mui/material/TextField";
import { FilterOptionsState } from "@mui/material/useAutocomplete";
import { styled } from "@mui/styles";
import { ChangeEventHandler, SyntheticEvent } from "react";
import { BLACK, LIGHT_GREY } from "../../utils/colors";

type AutocompleteProps = {
  selectOnFocus?: boolean;
  clearOnBlur?: boolean;
  handleHomeEndKeys?: boolean;
  freeSolo?: boolean;
  placeholder?: string;
  multiple?: boolean;
  label?: string;
  options?: any[];
  loading?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  name?: string;
  id?: string;
  value?: any;
  isOpaque?: boolean;
  defaultValue?: any;
  size?: "small" | "medium" | undefined;
  className?: string;
  disableCloseOnSelect?: boolean;
  error?: boolean;
  helperText?: string;
  sx?: SxProps<Theme>;
  startAdornment?: JSX.Element | null;
  endAdornment?: JSX.Element | null;
  getOptionLabel: (option: any) => string;
  renderOption?: (props: any, option: any) => any;
  onChangeChild?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  groupBy?: (option: any) => string;
  onChange?: (_: SyntheticEvent<Element, Event>, option: any) => void;
  onInputChange?: (_: SyntheticEvent<Element, Event>, value: string) => void;
  filterOptions?: (options: any[], state: FilterOptionsState<any>) => any[];
};

export const OpaqueTextField = styled(MuiTextField)(() => ({
  // marginBottom: "24px",
  // width: "100%",
  // height: "12px",
  "label + &": {
    marginTop: "10px",
  },

  "& .MuiInputBase-root": {
    background: LIGHT_GREY,
    height: "50px !important",
  },

  "& .MuiInputBase-input": {
    // padding: 0,
    width: "100%",
    background: LIGHT_GREY,
    fontWeight: 500,
    color: BLACK,
  },
}));

export function Autocomplete({
  selectOnFocus,
  clearOnBlur,
  handleHomeEndKeys,
  freeSolo,
  multiple,
  name,
  id,
  className,
  label,
  options = [],
  loading,
  disabled,
  fullWidth,
  value,
  isOpaque = false,
  defaultValue,
  disableCloseOnSelect,
  size,
  placeholder,
  getOptionLabel,
  renderOption,
  groupBy,
  error,
  helperText,
  onChange,
  onInputChange,
  filterOptions,
  sx,
  startAdornment,
  endAdornment,
}: AutocompleteProps) {
  return (
    <MuiAutocomplete
      value={value ? value : null}
      selectOnFocus={selectOnFocus}
      clearOnBlur={clearOnBlur}
      handleHomeEndKeys={handleHomeEndKeys}
      freeSolo={freeSolo}
      onInputChange={onInputChange}
      noOptionsText="Nenhum opção encontrado"
      multiple={multiple}
      className={className}
      size={size}
      id={id}
      disableCloseOnSelect={disableCloseOnSelect}
      defaultValue={defaultValue}
      groupBy={groupBy}
      loadingText="Carregando..."
      loading={loading}
      options={options}
      renderOption={renderOption}
      disabled={disabled}
      fullWidth={fullWidth}
      getOptionLabel={getOptionLabel}
      onChange={onChange}
      filterOptions={filterOptions}
      sx={sx}
      renderInput={(params) => (
        <>
          {isOpaque ? (
            <OpaqueTextField
              {...params}
              name={name}
              label={label}
              placeholder={placeholder}
              value={value}
              error={error}
              helperText={helperText}
              fullWidth={true}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <>
                    {startAdornment}
                    {params.InputProps.startAdornment}
                  </>
                ),
                endAdornment: (
                  <>
                    {endAdornment}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          ) : (
            <MuiTextField
              {...params}
              name={name}
              placeholder={placeholder}
              label={label}
              value={value}
              error={error}
              helperText={helperText}
              fullWidth={true}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <>
                    {startAdornment}
                    {params.InputProps.startAdornment}
                  </>
                ),
                endAdornment: (
                  <>
                    {endAdornment}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        </>
      )}
    />
  );
}
